import React from "react";

import ImportExportMenu from "Components/Common/DataImport/ImportExportMenu";
import { DataImportConfig } from "Components/Common/DataImport/dataImportFields";
import {
  exportRiskRatingsToCSV,
  importRiskRating,
} from "common/services/risk-assessments.service";

const importConfig: DataImportConfig = {
  title: "Risk Assessment Ratings",
  entityLabel: "risk assessment rating",
  icon: "ri-alert-line",
  templateFile: "risk_assessment_ratings_import_template.csv",
  importFn: importRiskRating,
  fields: [
    {
      key: "name",
      label: "Name",
      required: true,
      hint: "Must be unique across risk assessment ratings",
    },
    { key: "description", label: "Description" },
  ],
};

/** Import/export menu for the risk assessment ratings table. */
const Import = ({
  apiParams,
  onImported,
}: {
  apiParams?: any;
  onImported?: () => void;
}) => (
  <ImportExportMenu
    resource="risk-assessment-rating"
    config={importConfig}
    exportFn={exportRiskRatingsToCSV}
    exportFileName="Risk_Assessment_Ratings_Export.csv"
    apiParams={apiParams}
    onImported={onImported}
  />
);

export default Import;
